import { ProductInfo } from "../../types";
import { BASE_URL } from "../../base";

export const getProductImage = (image: string) => image ? `${BASE_URL}/static/${image}` : 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
